import { Partial } from '@40seas/entities/common';
import { InsuranceCoverRequest } from './insurance.cover-requests.entity';

export class UpdateInsuranceCoverRequestDto extends Partial(InsuranceCoverRequest) {}
